var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"login_register_forgetPassword w1345"},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"},[_vm._m(0),_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tit"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/login/logo.png"),"alt":""}})])])
}]

export { render, staticRenderFns }